const CONFIG = {
    url: process.env.VUE_APP_SQUIDEX_URL,
    appName: process.env.VUE_APP_SQUIDEX_APPNAME,
    clientId: process.env.VUE_APP_SQUIDEX_CLIENTID,
    clientSecret: process.env.VUE_APP_SQUIDEX_CLIENTSECRET   
};
const days = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];


function getBearerToken() {
    return localStorage.getItem('token');
}

function setBearerToken(token) {
    localStorage.setItem('token', token);
}

function clearBearerToken() {
    localStorage.removeItem('token');
}

export function getDate(dateMod, format) {
   var d = new Date(dateMod);
   format = (format != '' ? format : 'd-m-y');

   if(format === 'd-m'){
      return d.getDate() + ' ' + getMonthName(d.getMonth());
   }
   else if(format === 'd-m-y t'){
      if(d.getHours() == '0' && d.getMinutes() == '0'){
         return days[d.getDay()] + ' ' + d.getDate() + ' ' + getMonthName(d.getMonth()) + ' ' + d.getFullYear();
      }else{
         return days[d.getDay()] + ' ' + d.getDate() + ' ' + getMonthName(d.getMonth()) + ' ' + d.getFullYear() + ' alle ' + (d.getHours() > 9 ?  d.getHours() : '0'+d.getHours()) + ':' + (d.getMinutes() > 9 ?  d.getMinutes() : '0'+d.getMinutes());
      }
   }
   else{   
      return d.getDate() + ' ' + getMonthName(d.getMonth()) + ' ' + d.getFullYear();
   }
} 

function getMonthName(monthInt){
   const monthNames = ["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"];
   return monthNames[monthInt];
}

export async function getPost(id, section) {   
   let url = '';
   
   if(section != ''){
      url = `api/content/${CONFIG.appName}/${section}/${id}`;
   }
   else{
      url = `api/content/${CONFIG.appName}/${id}`;
   }

   return await getContent(url);  
   // return parsePost(json);
}

export async function getPage(slug, section) {
    const json = await getContent(`api/content/${CONFIG.appName}/${section}/?$filter=data/slug/iv eq '${slug}'`);
    const { items } = json;

    if (items.length === 0) {
        return null;
    }
    return parseArticolo(items[0]);
}

export async function getAssociatedPosts(id, section) {
    const json = await getContent(`api/content/${CONFIG.appName}/${section}/?$filter=data/s3/iv eq '${id}'`);

    const { total, items } = json;

    return { total, posts: items.map(x => parseArticolo(x)) };
}

export async function getAssociatedPostsIDs(ids) {
    let idString = ids.toString();
    const json = await getContent(`api/content/${CONFIG.appName}?ids=${idString}`);
    const { total, items } = json;

    return { total, posts: items.map(x => parseArticolo(x)) };
}

export function getPostsIDs(ids) {
    let idString = ids.toString();
    const json = getContent(`api/content/${CONFIG.appName}?ids=${idString}`);
    const { total, items } = json;

    return { total, posts: items.map(x => parseArticolo(x)) };
}

export async function getPosts(section) {
    const json = await getContent(`api/content/${CONFIG.appName}/${section}`);
    const { total, items } = json;

    return { total, posts: items.map(x => parseArticolo(x)) };
}

export async function getPages(section) {
    const json = await getContent(`api/content/${CONFIG.appName}/${section}`);
    const { total, items } = json;

    return { total, pages: items.map(x => parsePage(x)) };
}

export function parseArticolo(response) {   
   return {
      id: response.id,
      schema: response.schemaName,
      area: response.schemaName,
      areeSpecializzazione: (response.data.areeSpecializzazione ? response.data.areeSpecializzazione.iv : null),
      argomenti: (response.data.argomenti ? response.data.argomenti.iv : null),
      breve: (response.data.breve ? response.data.breve.iv : null),
      corpo: (response.data.corpo ? response.data.corpo.iv : null),
      created: getDate(response.lastModified),
      destUrl: (response.data.link ? response.data.link.iv : ''),
      image: (response.data.immagineUnsplash ? response.data.immagineUnsplash.iv : null),
      immaginiList: (response.data.immaginiList ? response.data.immaginiList.iv : null),
      indirizzo: (response.data.indirizzo ? response.data.indirizzo.iv : null),
      listaDocumenti: (response.data.listaDocumenti ? response.data.listaDocumenti.iv : null),
      linkList: (response.data.linkList ? response.data.linkList.iv : null),
      linkEsterni: (response.data.linkEsterni ? response.data.linkEsterni.iv : null),
      maggioriInfo: (response.data.maggioriInformazioni ? response.data.maggioriInformazioni.iv : null),
      modified: getDate(response.lastModified),
      nome: (response.data.nome ? response.data.nome.iv : null),
      logo: (response.data.logo ? response.data.logo.iv : null),
      sito: (response.data.sito ? response.data.sito.iv : null),
      slug: (response.data.slug ? response.data.slug.iv : null),
      timeRead: getTimeRead((response.data.corpo ? response.data.corpo.iv : '')),
      titolo: (response.data.titolo ? response.data.titolo.iv : null),
      s3: (response.data.s3 ? response.data.s3.iv : null),
   };
}

function getTimeRead(text){
   let minutes = Math.ceil(text.split(" ").length / 130 );
   return minutes + " " + (minutes === 0 ? 'Minuto' : 'Minuti');
}

/*function parsePost(response) {   
   return {
      id: response.id,
      created: getDate(response.lastModified),
      titolo: response.data.titolo.iv,
      breve: response.data.Breve.iv,
      corpo: response.data.Corpo.iv,
      argomenti: response.data.argomenti.iv,
      image: response.data.image.iv,
      immaginiList: response.data.immaginiList.iv,
      linkEsterni: (response.data.linkEsterni ? response.data.linkEsterni.iv : null),
      linkList: (response.data.linkList ? response.data.linkList.iv : null),
      listaDocumenti: (response.data.listaDocumenti ? response.data.listaDocumenti.iv : null),
      slug: response.data.slug.iv
   };
}*/

function parsePage(response) {
   return {
      id: response.id,
      titolo: (response.data.titolo ? response.data.titolo.iv : null),
      breve: (response.data.breve ? response.data.breve.iv : null),
      corpo: (response.data.corpo ? response.data.corpo.iv : null),      
      image: (response.data.immagineUnsplash ? response.data.immagineUnsplash.iv : null),
      immaginiList: (response.data.immaginiList ? response.data.immaginiList.iv : null),
      s3: (response.data.s3 ? response.data.s3.iv : null),
      areeSpecializzazione: (response.data.areeSpecializzazione ? response.data.areeSpecializzazione.iv : null),
      linkEsterni: (response.data.linkEsterni ? response.data.linkEsterni.iv : null),
      linkList: (response.data.linkList ? response.data.linkList.iv : null),
      listaDocumenti: (response.data.listaDocumenti ? response.data.listaDocumenti.iv : null),
      argomenti: (response.data.argomenti ? response.data.argomenti.iv : null),
      slug: response.data.slug.iv,
      logo: (response.data.logo ? response.data.logo.iv : null),
      indirizzo: (response.data.indirizzo ? response.data.indirizzo.iv : null),
      sito: (response.data.sito ? response.data.sito.iv : null),
      nome: (response.data.nome ? response.data.nome.iv : null),      
      area: response.schemaName
   };
}

export async function fetchBearerToken() {
    // Check if we have already a bearer token in local store.
    let token = getBearerToken();

    if (token) {
        return token;
    }

    const body = `grant_type=client_credentials&scope=squidex-api&client_id=${CONFIG.clientId}&client_secret=${CONFIG.clientSecret}`;

    // Get the bearer token. Ensure that we use a client id with readonly permissions.
    const response = await fetch(buildUrl('identity-server/connect/token'), { 
        method: 'POST', 
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body 
    });

    if (!response.ok) {
        throw new Error(`Failed to retrieve token, got ${response.statusText}`);
    }

    const json = await response.json();

    token = json.access_token;

    // Cache the bearer token in the local store.
    setBearerToken(token);

    return token;
}

function getContent(url) {
    return getContentInternal(url, true);
}

async function getContentInternal(url, retry) {
    // Fetch the bearer token.
    const token = await fetchBearerToken();

    const response = await fetch(buildUrl(url), {
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
            'X-Resolve-Urls' : '*'
        }
    });     

    if (!response.ok) {
        if (response.status === 403 || response.status === 401) {
            // If we get an error we clear the bearer token and retry the request.
            clearBearerToken();

            if (retry) {
                return getContentInternal(url);
            }
        }

        throw new Error(`Failed to retrieve content, got ${response.statusText}`);
    }

    return await response.json();
}

function buildUrl(url) {
    if (url.length > 0 && url.startsWith('/')) {
        url = url.substr(1);
    }

    const result = `${CONFIG.url}/${url}`;

    return result;
}